import styled from 'styled-components';

const LeafletButtons = styled.div`
  position: absolute;
  right: 24px;
  top: 10px;
  z-index: 100;
`;

const TxtVideoContainer = styled.div`
  position: absolute;
  top: 0;
  left: 15;
  width: ${props => props.width};
  height: ${props => props.height};
  opacity: ${props => (props.option === 'opt4' ? 0.75 : 0)};
  z-index: ${props => (props.option === 'opt4' ? 10 : -10)};
`;

const DivOnVideo = styled.div`
  position: absolute;
  top: 0;
  width: ${props => (props.isTxtVideo ? '100%' : 'calc(100% - 30px)')};
  height: 100%;
`;

export default {
  LeafletButtons,
  TxtVideoContainer,
  DivOnVideo
};
